export default __webpack_public_path__ + "static/assets/418b2c6093a9ab9daa41f27868de425c.png";